// @flow
import * as React from 'react';
import type { BadgeProps } from './Badge.types';
import BadgeWrapper from './Badge.style';

const Badge = (props: BadgeProps) => {
  const { color, children, ...rest } = props;

  return (
    <BadgeWrapper type={color} {...rest}>
      {children}
    </BadgeWrapper>
  );
};

export default Badge;
